export default __webpack_public_path__ + "static/SofiaProMedium-0d300268a1884d973bd96ff5310e0d19.woff2";